import type { AcademyCollection, AcademyThemeOptions } from '~/components/academies/types/types';
import { Row, Stack, H3 } from '@workramp/ui';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import AcademyThemeCollectionCard from '../../common/academy-theme-collection-card';
import AcademyThemeContentCard from '../../common/academy-theme-content-card';
import AcademyThemeCardWrapper from '../../common/academy-theme-card-wrapper';

interface AcademyLearnerCollectionListProps {
  header: string;
  themeOptions: AcademyThemeOptions;
  collectionCardVersion: number;
  collections: AcademyCollection[];
  showHeader: boolean;
}

export function AcademyLearnerCollectionsList({
  header,
  collections,
  themeOptions,
  collectionCardVersion,
  showHeader,
}: AcademyLearnerCollectionListProps) {
  return (
    <Stack size={3}>
      <Row>{showHeader && <H3 className={academyCustomCSS.cardList.sectionTitle}>{header}</H3>}</Row>
      <Row>
        <AcademyThemeCardWrapper>
          {collections.map((collection) => {
            if (collectionCardVersion === 1) {
              return (
                <AcademyThemeContentCard
                  accentColor={themeOptions.accentColor}
                  key={collection.id}
                  bannerImage={collection.bannerImage}
                  cardStyle={themeOptions.cardStyle}
                  description={collection.description}
                  footerContentType="item"
                  name={collection.name}
                  numContent={collection.numContent}
                  contentId={collection.id}
                  url={`/collections/${collection.id}`}
                  isCollection
                />
              );
            }
            return (
              <AcademyThemeCollectionCard
                key={collection.id}
                bannerImage={collection.bannerImage}
                description={collection.description}
                name={collection.name}
                numContent={collection.numContent}
                collectionId={collection.id}
                url={`/collections/${collection.id}`}
              />
            );
          })}
        </AcademyThemeCardWrapper>
      </Row>
    </Stack>
  );
}
